<template>
  <div class="relative h-[42px]">
    <Button light @click="toggleFilter()">
      <i class="fa-solid fa-filter text-gray-500"></i>
      <span class="mx-2">Filtrar </span>
      <div class="bg-blue-600 text-xs font-bold size-4 rounded-full text-white mr-2" v-if="filterSize > 0">
        {{ filterSize }}
      </div>
      <i class="transition cursor-pointer fa-solid text-gray-500 fa-chevron-down" :class="filterToggle ? 'rotated-icon ' : ''" />
    </Button>

    <TheTransition>
      <Card v-if="filterToggle" :class="[filters.length >= 5 ? 'w-[720px]' : 'w-[560px]', 'absolute top-100 p-5 right-0 z-[80] shadow-lg mt-2 ']">
        <div :class="[filters.length >= 5 ? 'grid-cols-2' : 'grid-cols-1', 'grid gap-5']">
          <div v-for="(item, i) in filters" :key="i">
            <InputText
              v-if="item.type == 'text'"
              v-model="inputValues[i]"
              :label="item.label"
              :placeholder="item.placeholder ? item.placeholder : `Digite o ${item.label.toLowerCase()}`" />

            <InputNumber v-if="item.type == 'number'" type="number" v-model="inputValues[i]" :label="item.label" :placeholder="item.placeholder ? item.placeholder : `Selecione ${item.label.toLowerCase()}`" />
            <Select v-if="item.type == 'select'" :items="item.items" v-model="inputValues[i]" :label="item.label" clearable :placeholder="item.placeholder ? item.placeholder : `Selecione ${item.label.toLowerCase()}`" />
            <InputDate v-if="item.type == 'date'" v-model="inputValues[i]" :label="item.label" clearable :placeholder="item.placeholder ? item.placeholder : `Selecione ${item.label.toLowerCase()}`" />
            <MonthPiker v-if="item.type == 'monthly'" v-model="inputValues[i]" :label="item.label" clearable :placeholder="item.placeholder ? item.placeholder : `Selecione ${item.label.toLowerCase()}`" />
            <InputDateRange v-if="item.type == 'range'" v-model="inputValues[i]" :label="item.label" clearable :placeholder="item.placeholder ? item.placeholder : `Selecione ${item.label.toLowerCase()}`" />
            <InputZoom
              v-if="item.type == 'zoom'"
              v-model="inputValues[i]"
              :label="item.label"
              :database="item.database"
              :item-text="item.itemText"
              :item-value="item.itemValue"
              :table-filter="item.tableFilter"
              :item-autocomplete="item.itemAutocomplete"
              :placeholder="item.placeholder ? item.placeholder : `Selecione ${item.label.toLowerCase()}`"
              clearable />
            <InputZoomMultiple
              v-if="item.type == 'zoomMultiple'"
              v-model="inputValues[i]"
              :label="item.label"
              :database="item.database"
              :item-text="item.itemText"
              :item-value="item.itemValue"
              :table-filter="item.tableFilter"
              :item-autocomplete="item.itemAutocomplete"
              :placeholder="item.placeholder ? item.placeholder : `Selecione ${item.label.toLowerCase()}`"
              clearable />
          </div>
        </div>
        <div class="border-t my-5" />
        <Flex justify-end gap-2>
          <Button danger outlined label="Limpar" icon="fa-solid fa-xmark" @click="emitClear" />
          <Button primary label="Buscar" icon="fa-solid fa-magnifying-glass" @click="emitConfirm" />
        </Flex>
      </Card>
    </TheTransition>
  </div>
</template>

<script setup>
import moment from 'moment'
import { ref, onMounted, watch, onBeforeUnmount } from 'vue'

const emit = defineEmits(['filter'])
const props = defineProps({
  modelValue: {
    type: Array,
    default: [],
  },
  filterValues: {
    type: Array,
    default: [],
  },
  filters: {
    type: Array,
    default: [],
  },
})

const inputValues = ref({})

const items = ref([])

const filterToggle = ref(false)
const filterSize = ref(0)

const emitConfirm = () => {
  filterToggle.value = false
  filterAll()
}

const emitClear = () => {
  filterToggle.value = false
  clearFilterAll()
  emit('clear')
}

const toggleFilter = () => {
  filterToggle.value = !filterToggle.value
}

const filterAll = async () => {
  let params = []
  props.filters.forEach((filter, index) => {
    if (inputValues.value[index] && inputValues.value[index] !== undefined) {
      const param = { column: filter.param, value: inputValues.value[index] }
      if (filter.type == 'zoomMultiple') {
        if (Array.isArray(param.value) && param.value.length > 0 && typeof param.value[0] === 'object') {
          param.value = param.value.map((el) => el[filter.itemValue])
        }
      }
      if (filter.type == 'range') {
        param.value.forEach((el) => {
          el = moment(el).format()
        })
      }
      if (filter.type == 'date') {
        param.value = moment(param.value).format()
      }
      if (filter.tableFilter) {
        param.tableFilter = filter.tableFilter
        param.table = filter.tableFilter
      }
      if (filter.table) {
        param.tableFilter = filter.table
        param.table = filter.table
      }
      if (filter.operator) {
        param.operator = filter.operator
      }
      if (filter.operator === 'is not in' && !Array.isArray(param.value)) {
        param.value = [param.value]
      }
      //  Valores
      if (Array.isArray(param.value) && param.value.length == 0) {
        param.value = null
      }

      if (typeof param.value === 'string' && param.value.includes(',') && /^\d+,\d+$/.test(param.value)) {
        param.value = param.value.replace(',', '.')
      }
      if (param.value) {
        params.push(param)
      }
    }
  })

  filterSize.value = params.length
  const filterObject = {
    params,
  }
  emit('filter', filterObject)
  filterToggle.value = false

  if (!items.value) {
    items.value = []
  }
}

const clearFilterAll = async () => {
  for (const key in inputValues.value) {
    inputValues.value[key] = null
  }
  filterSize.value = 0
}

const filterTracker = () => {
  if (props.filterValues && props.filterValues.length > 0) {
    props.filters.forEach((filter, index) => {
      const itemFound = props.filterValues.find((i) => i.column === filter.param)

      if (itemFound) {
        inputValues.value[index] = itemFound.value
        filterSize.value = props.filterValues.length
      }
    })
  }
}

const handleKeydown = (event) => {
  // if (event.key === "Enter") {
  //   // emitConfirm()
  // }
}

watch(
  () => props.filterValues,
  () => {
    filterTracker()
  },
  { immediate: true, deep: true },
)

watch(
  () => props.modelValue,
  (newVal) => {
    filterSize.value = newVal ? newVal.length : 0
  },
  { immediate: true },
)

onMounted(() => {
  filterTracker()
  window.addEventListener('keydown', handleKeydown)
})

onBeforeUnmount(() => {
  window.removeEventListener('keydown', handleKeydown)
})
</script>

<style>
.icon {
  cursor: pointer;
}
.rotated-icon {
  transform: rotate(-180deg);
  transition: transform 0.3s ease ease-out;
}
.transition {
  transition: transform 0.3s ease-out;
}
</style>
